import {
    GET_TEAM_LISTS_REQUEST,
    GET_TEAM_LISTS_SUCCESS,
    GET_TEAM_LISTS_ERROR,

    PICK_A_TEAM_REQUEST,
    PICK_A_TEAM_SUCCESS,
    PICK_A_TEAM_ERROR,

    GET_COACH_LIST_REQUEST,
    GET_COACH_LIST_SUCCESS,
    GET_COACH_LIST_ERROR,

    PICK_A_COACH_REQUEST,
    PICK_A_COACH_SUCCESS,
    PICK_A_COACH_ERROR,
  } from "../../constants/AddUser/AddPlayer.const";
  
  const initialState = {
    teamListsReq: false,
    teamListsData: null,
    teamListsError: null,

    selectedTeamReq: false,
    selectedTeamData: null,
    selectedTeamError: null,

    coachListsReq: false,
    coachListsData: null,
    coachListsError: null,

    selectedCoachReq: false,
    selectedCoachData: null,
    selectedCoachError: null,
    selectedCoachLoader: false,
  };
  
  export default function (state = initialState, action) {
    switch (action.type) {
  
      // For GET Team List
      case GET_TEAM_LISTS_REQUEST:
        return {
          ...state,
          teamListsReq: true,
        };
      case GET_TEAM_LISTS_SUCCESS:
        return {
          ...state,
          teamListsData: action.payload,
        };
      case GET_TEAM_LISTS_ERROR:
        return {
          ...state,
          teamListsError: action.error,
        };

        // For player pick a team
      case PICK_A_TEAM_REQUEST:
        return {
          ...state,
          selectedTeamReq: true,
        };
      case PICK_A_TEAM_SUCCESS:
        return {
          ...state,
          selectedTeamData: action.payload,
        };
      case PICK_A_TEAM_ERROR:
        return {
          ...state,
          selectedTeamError: action.error,
        };

        // For GET Coach List
      case GET_COACH_LIST_REQUEST:
        return {
          ...state,
          coachListsReq: true,
        };
      case GET_COACH_LIST_SUCCESS:
        return {
          ...state,
          coachListsData: action.payload,
        };
      case GET_COACH_LIST_ERROR:
        return {
          ...state,
          coachListsError: action.error,
        };

          // For player pick a Coach
      case PICK_A_COACH_REQUEST:
        return {
          ...state,
          selectedCoachReq: true,
          selectedCoachLoader: true,
        };
      case PICK_A_COACH_SUCCESS:
        return {
          ...state,
          selectedCoachData: action.payload,
          selectedCoachLoader: true,
        };
      case PICK_A_COACH_ERROR:
        return {
          ...state,
          selectedCoachError: action.error,
          selectedCoachLoader: true,
        };

      default:
        return state;
    }
  }
  